import { render, staticRenderFns } from "./ChangeEmailModal.vue?vue&type=template&id=7870fecf"
import script from "./ChangeEmailModal.vue?vue&type=script&lang=js"
export * from "./ChangeEmailModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeEmailModal.vue?vue&type=style&index=0&id=7870fecf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports